module.exports = __webpack_public_path__ + "static/img/13.c6e26bad.png";